/**
 * @fileoverview セッションストレージ関連
 */

//------------
// セッションストレージキー
//------------
// 作成／編集対象の分析記事ID
export const SESSION_STORAGE_CREATE_ARTICLE_ID_KEY = "create_article_id";

// 初回いいね記事リスト
export const SESSION_STORAGE_FIRST_FAVORIT = "first_favorit";

/**
 * セッションストレージリセット
 *
 * @note 現在未使用
 */
export function resetSessionStorage() {
  //------------
  // セッションストレージの初回いいね記事クリア
  //------------
  sessionStorage.removeItem(SESSION_STORAGE_FIRST_FAVORIT);
}

/**
 * 初回いいね記事リスト追加
 */
export function addFirstFavoritList(id: string) {
  //------------
  // 取得
  //------------
  // リスト
  let list: string[];

  // セッションストレージから取得
  const serializedData = sessionStorage.getItem(SESSION_STORAGE_FIRST_FAVORIT);
  if (serializedData) {
    // シリアル化状態なので、リストに変換
    list = JSON.parse(serializedData);

    //------------
    // フェールセーフ
    //------------
    // 既にリストにある場合は何もしない
    if (list.includes(id)) {
      return;
    }

    // リストに追加
    list.push(id);
  } else {
    // リストを生成
    list = [id];
  }

  //------------
  // 保存
  //------------
  // シリアル化
  const updateSerializedData = JSON.stringify(list);
  sessionStorage.setItem(SESSION_STORAGE_FIRST_FAVORIT, updateSerializedData);
}

/**
 * 初回いいね記事リスト削除
 */
export function removeFirstFavoritList(id: string) {
  //------------
  // 取得
  //------------
  // セッションストレージから取得
  const serializedData = sessionStorage.getItem(SESSION_STORAGE_FIRST_FAVORIT);
  if (!serializedData) {
    // リストがないなら、ないもしない
    return;
  }

  // シリアル化状態なので、リストに変換
  const list: string[] = JSON.parse(serializedData);

  // リスト中にない場合は何もしない
  if (!list.includes(id)) {
    return;
  }

  // リストに追加
  const removedList = list.filter((articleId) => articleId != id);

  //------------
  // 保存
  //------------
  // シリアル化
  const updateSerializedData = JSON.stringify(removedList);
  sessionStorage.setItem(SESSION_STORAGE_FIRST_FAVORIT, updateSerializedData);
}

/**
 * 初回いいね記事リストにあるかどうか
 */
export function existFirstFavoritList(id: string) {
  //------------
  // 取得
  //------------
  // セッションストレージから取得
  const serializedArray = sessionStorage.getItem(SESSION_STORAGE_FIRST_FAVORIT);
  if (!serializedArray) {
    // リスト自体なし
    return false;
  }

  //------------
  // 有無の判定
  //------------
  // シリアル化状態なので、リストに変換
  const list = JSON.parse(serializedArray);

  // リスト内にあるかどうかを返す
  return list.includes(id);
}
